module.exports = {"id":"189221","name":"João Aurélio","rating":"74","photo":"./data/images/photos/1/189221.png","club":{"name":"Vit. Guimarães","logo":"./data/images/clubs/Vit.Guimaraes.png"},"positions":["DD","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoaoAurelio0.json
// module id = 2028
// module chunks = 0